import styled from 'styled-components';
export const List = styled.ul `
  display: inline-flex;
`;
export const ListItem = styled.li `
  display: flex;
  align-items: center;
`;
export const Divider = styled.span `
  margin: 0 0.3em 0;
  user-select: none;
  display: inline-block;
`;
//# sourceMappingURL=styles.js.map